import { render, staticRenderFns } from "./OnboardingSelfie.vue?vue&type=template&id=743f525e&scoped=true"
import script from "./OnboardingSelfie.vue?vue&type=script&lang=js"
export * from "./OnboardingSelfie.vue?vue&type=script&lang=js"
import style0 from "./OnboardingSelfie.vue?vue&type=style&index=0&id=743f525e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743f525e",
  null
  
)

export default component.exports